import EmptySearchResult from "./EmptySearchResult";

export default EmptySearchResult;
